import { useDomainRepository, useSimpleRequest } from "hooks";
import BusinessLogicException from "exceptions/BusinessLogicException";
import { getTransactionsOpXHeadersHistory } from "features/transactions/api";
import {
    makeState,
    Repository as BankingSDKLoggingRepository,
    type BankingSDKLoggingRepositoryState
} from "./repository";
import { reducer, RepositoryActionType } from "../Repository";
import { useTransactionContext } from "../../TransactionProvider";

export const useBankingSDKLogging = () => {
    const transaction = useTransactionContext();

    const request = useSimpleRequest();

    const repository = useDomainRepository<
        BankingSDKLoggingRepositoryState,
        RepositoryActionType
    >({
        reducer: reducer(makeState),
        initializerArg: makeState(),
        factory: (state, dispatch) => new BankingSDKLoggingRepository(
            state,
            dispatch,
            async (searchQueryParams?: string) => {
                const { data } = await request(() => getTransactionsOpXHeadersHistory(searchQueryParams));

                return data;
            },
            transaction
        )
    });

    if (repository instanceof BankingSDKLoggingRepository) {
        return repository;
    }

    throw new BusinessLogicException('Repository is not an instance of BankingSDKLoggingRepository', {
        repository
    });
};

export default useBankingSDKLogging;
